export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-paypal-6ab00558278950bb13e70c04b0da246b.svg";